import { render, staticRenderFns } from "./RecuentoStatus.vue?vue&type=template&id=2c17eaa6"
import script from "./RecuentoStatus.vue?vue&type=script&lang=js"
export * from "./RecuentoStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports